import styled from 'styled-components';

export const Content = styled.div`
 .ant-divider-horizontal {
  margin: 15px 0 15px;
 }
 width: auto;
 height: 500px;
 overflow: auto;
`;

export const Head = styled.div`
 display: flex;
 align-items: center;
`;

export const Title = styled.div`
 margin-left: 10px;
 font-style: normal;
 font-weight: 500;
 font-size: 20px;
 line-height: 22px;
 color: #2b314f;
`;

export const ConnectName = styled.div`
 margin-bottom: 5px;
 font-style: normal;
 font-weight: 500;
 font-size: 16px;
 line-height: 20px;
 color: transparent;
 -webkit-background-clip: text;
 background-clip: text;
 color: #4886be;
 margin-top: 20px;
`;

export const ResourceName = styled.div`
 margin-bottom: 5px;
 font-style: normal;
 font-weight: 500;
 font-size: 15px;
 line-height: 20px;
 color: transparent;
 -webkit-background-clip: text;
 background-clip: text;
 color: black;
 margin-bottom: 10px;
`;

export const FieldName = styled.div`
 margin-bottom: 5px;
 font-style: normal;
 font-weight: 500;
 font-size: 14px;
 line-height: 20px;
 color: transparent;
 -webkit-background-clip: text;
 background-clip: text;
 color: black;
`;

export const NumberField = styled.div`
 margin-bottom: 5px;
 font-style: normal;
 font-weight: 500;
 font-size: 15px;
 line-height: 20px;
 color: transparent;
 -webkit-background-clip: text;
 background-clip: text;
 color: black;
 margin-right: 20px;
`;

export const FactoryCode = styled.div`
 margin-bottom: 5px;
 font-style: normal;
 font-weight: 500;
 font-size: 14px;
 line-height: 20px;
 color: transparent;
 -webkit-background-clip: text;
 background-clip: text;
 color: #878787;
`;

export const CommentField = styled.div`
 margin-bottom: 5px;
 font-style: normal;
 font-weight: 500;
 font-size: 12px;
 line-height: 20px;
 color: transparent;
 -webkit-background-clip: text;
 background-clip: text;
 color: #878787;
 width: 350px;
`;

export const Text = styled.span`
 font-style: normal;
 font-weight: 500;
 font-size: 14px;
 line-height: 22px;
 color: #2b314f;
`;

export const DeviceName = styled.div`
 margin-bottom: 5px;
 font-style: normal;
 font-weight: normal;
 font-size: 12px;
 line-height: 14px;
 color: #a3a3a5;
`;

export const NumberDevice = styled.div`
 margin-bottom: 5px;
 font-style: normal;
 font-weight: 500;
 font-size: 16px;
 line-height: 16px;
 color: #a3a3a5;
`;
